import { render, staticRenderFns } from "./ModalContentAddNewProject.vue?vue&type=template&id=59461606&scoped=true&"
import script from "./ModalContentAddNewProject.vue?vue&type=script&lang=js&"
export * from "./ModalContentAddNewProject.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentAddNewProject.vue?vue&type=style&index=0&id=59461606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59461606",
  null
  
)

export default component.exports